import { useEffect, useRef, useState } from "react";
import axiosHttp from "../../interceptors/axios-interceptor";
import { TRANSACTION_EXPIRATIONS } from "../../../constants/api";
import { errorNotify } from "../../../shared/notifications";
import { persianLanguage } from "../../../constants/persianTerms";
import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    Pager,
    Paging,
    Scrolling,
    Selection,
  } from 'devextreme-react/data-grid';
import { onExporting } from "../../../shared/excel-export";
import { persianPrice } from "../../../shared/persian-number";
import { DATAGRID_ALLOWED_PAGE_SIZES } from "../../../constants/constant-arrays";
import { DEFAULT_DATAGRID_PAGE_SIZE } from "../../../constants/constant-numbers";
import { useAuth } from "../../auth/auth-provider/auth-provider";

export default function TransactionExpirationDurationHistory(props){
    const auth = useAuth()
    const dataGridRef = useRef(null);

    const [histories, setHistories] = useState([]);
    

    useEffect(() => {
        getTransactionExpirationDurationHistories();
    }, [props.duration]);

    const getTransactionExpirationDurationHistories = () => {
        axiosHttp.get(`${TRANSACTION_EXPIRATIONS}${auth?.user?.id}/histories/`).then(
            response => {
                setHistories(response.data.data);
            }
        ).catch(
            error => {
                if(error.response.status === 404){

                } else {
                    errorNotify(persianLanguage.phrase.error.ERROR_400);
                }

            }
        );
    }
    const calculateExpirationDuration = (data) => {
        return persianPrice(data.expirationDuration)
    }

    const calculatePreviousExpirationDuration = (data) => {
        return persianPrice(data.previousExpirationDuration)
    }

    if(histories){
        return  (
            <>

            <div className="mt-5 user-select-none bg-primary-main border border-2 border-primary-fourth-30p box-shadow-0-4-4-0 mx-[28px]">
             <div className="border border-b-2 box-shadow-0-4-4-0 px-[26px] py-[14px] pb-5">
                {
                    `
                    ${persianLanguage.word.general.HISTORY}
                    ${persianLanguage.phrase.transaction.AUTOMATIC_TRANSACTION_EXPIRATION_DURATION} 
                    
                    `
                }

              </div>

                    <DataGrid
                    id="grid-container"
                    keyExpr="id"
                    dataSource={histories}
                    ref={dataGridRef}
                    rtlEnabled={true}
                    showBorders={true}
                    className="pb-5 mx-5 mb-5 mt-[50px] custom-datagrid-bg"
                    allowColumnResizing={true}
                    onExporting={onExporting}
                    >
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Scrolling columnRenderingMode="virtual" />
                        <Selection mode="multiple"/>
                        <FilterRow visible={true} />
                        <Paging defaultPageSize={DEFAULT_DATAGRID_PAGE_SIZE} />
                        <Pager
                            showPageSizeSelector={true}
                            showNavigationButtons={true}
                            showInfo={true}
                            infoText={'صفحه {0} از {1} ({2} مورد) '}
                            displayMode={'compact'}
                            visible={"totalCount > 0"}
                            allowedPageSizes={DATAGRID_ALLOWED_PAGE_SIZES}
                        />
                        <ColumnChooser
                            enabled={true}
                            mode='select'
                        />
                        <Column
                        dataField="previousExpirationDuration"
                        allowFiltering={false}
                        calculateCellValue={calculatePreviousExpirationDuration}
                        dataType="string"
                        caption={`${persianLanguage.phrase.transaction.BEFOR_CHANGE}`}
                        />
                        <Column
                        allowFiltering={false}
                        dataField="expirationDuration"
                        calculateCellValue={calculateExpirationDuration}
                        dataType="string"
                        caption={`${persianLanguage.phrase.transaction.AFTER_CHANGE}`}
                        />
                        <Column
                        dataField="createdOnShamsi"
                        allowFiltering={false}
                        dataType="string"
                        caption={persianLanguage.phrase.general.CREATED_ON}
                        />
                    </DataGrid>

                </div>
                <div className="mb-[200px]"></div>
            </>
        );
    }
}